import { render } from "./App.vue?vue&type=template&id=7d8b6d01"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7d8b6d01&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@4.5.5__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__